import { FavoritedIcon, FavoriteIcon } from '@blocksuite/icons/rc';
import type { IconButtonProps } from '@pique/component';
import { IconButton } from '@pique/component';
import { useI18n } from '@pique/i18n';
import { cssVar } from '@toeverything/theme';
import Lottie from 'lottie-react';
import type { Ref } from 'react';
import { useCallback, useState } from 'react';

import favoritedAnimation from './favorited-animation/data.json';

export const FavoriteTag = ({
  ref,
  active,
  onClick,
  ...props
}: {
  active: boolean;
  ref?: Ref<HTMLButtonElement>;
} & Omit<IconButtonProps, 'children'>) => {
  const [playAnimation, setPlayAnimation] = useState(false);
  const t = useI18n();
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      onClick?.(e);
      setPlayAnimation(!active);
    },
    [active, onClick]
  );
  return (
    <IconButton
      tooltip={active ? t['Favorited']() : t['Favorite']()}
      tooltipOptions={{ side: 'top' }}
      ref={ref}
      onClick={handleClick}
      size="20"
      {...props}
    >
      {active ? (
        playAnimation ? (
          <Lottie
            loop={false}
            animationData={favoritedAnimation}
            onComplete={() => setPlayAnimation(false)}
            style={{ width: '20px', height: '20px' }}
          />
        ) : (
          <FavoritedIcon
            color={cssVar('primaryColor')}
            data-testid="favorited-icon"
          />
        )
      ) : (
        <FavoriteIcon />
      )}
    </IconButton>
  );
};
